<template>
    <Dialog
      :style="{ width: '40vw' }"
      :visible="displayComponent"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >
      <template #header>
        <h3>{{ modoEdicion }} equipo</h3>
      </template>
      <TabView v-model:activeIndex="active" @update:activeIndex="tabChange">
        <TabPanel header="Equipo computo">
          <div class="p-formgrid grid">
            <div class="p-field col">
              <label for="unidad">Unidad y Subred</label>
              <Dropdown
                id="unidad"
                appendTo="body"
                v-model="equipo.tUnidad"
                :options="lstUnidades"
                optionLabel="UNIDAD_SUBRED"
                placeholder="Selecciona una unidad"
                :filter="true"
                @change="escribeIP"
                :class="{
                  'p-invalid': submitted && !equipo.tUnidad,
                }"
              />
              <small class="p-invalid" v-if="submitted && !equipo.tUnidad"
                >La unidad es requerida.</small
              >
            </div>
    
            <div class="p-field col">
              <label for="tipo">Tipo</label>
              <Dropdown
                id="tipo"
                appendTo="body"
                v-model="equipo.tTipo"
                :options="lstTipos"
                optionLabel="Tipo"
                placeholder="Selecciona un tipo o escribe uno nuevo"
                :class="{
                  'p-invalid': submitted && !equipo.tTipo,
                }"
              />
              <small class="p-invalid" v-if="submitted && !equipo.tTipo"
                >El tipo es requerido.</small
              >
            </div>
          </div>
    
          <div class="p-field col">
            <div class="p-field-checkbox">
              <Checkbox
                id="NoSegmentado"
                name="NoSegmentado"
                :binary="true"
                v-model="NoSegmentado"
              />
              <label for="NoSegmentado"> Equipo no segmentado</label>
            </div>
          </div>
    
          <div class="p-formgrid grid">
            <div class="p-field col">
              <label for="nombre">Nombre del Equipo</label>
              <InputText
                autocomplete="off"
                id="nombre"
                v-model.trim="equipo.Nombre_equipo"
                autofocus
              />
              <span
                v-if="equipo.DatosOCS && ( (equipo.DatosOCS.NAME && equipo.DatosOCS.NAME.split('.')[0].toLowerCase() != equipo.Nombre_equipo?.toLowerCase()))"
                class="pi pi-info-circle ml-1"
                style="font-size: 1.2rem; color: red"
                v-tooltip="'Valor según OCS:\n' + equipo.DatosOCS?.NAME?.split('.')[0].toUpperCase() + '\n\nClic para cambiar'"
                @click="equipo.Nombre_equipo = equipo.DatosOCS?.NAME?.split('.')[0].toUpperCase()"
              ></span>
            </div>
            <div class="p-field col">
              <label for="ubicacion">Ubicación del Equipo</label>
              <InputText
                autocomplete="off"
                id="ubicacion"
                v-model.trim="equipo.Ubicacion"
                autofocus
              />
            </div>
          </div>
    
          <div class="p-formgrid grid">
            <div class="p-field col">
              <label for="usuario">Usuario</label>
              <InputText
                autocomplete="off"
                id="usuario"
                v-model.trim="equipo.Usuario"
                required="true"
                autofocus
              />
              <span
                v-if="equipo.DatosOCS && ( (equipo.DatosOCS.USERID && equipo.DatosOCS.USERID.toLowerCase() != equipo.Usuario?.toLowerCase()))"
                class="pi pi-info-circle ml-1"
                style="font-size: 1.2rem; color: red"
                v-tooltip="'Valor según OCS:\n' + equipo.DatosOCS?.USERID + '\n\nClic para cambiar'"
                @click="equipo.Usuario = equipo.DatosOCS?.USERID"
              ></span>
            </div>
            <div class="p-field col">
              <label for="area">Área</label>
              <InputText
                autocomplete="off"
                id="area"
                v-model.trim="equipo.Area"
                autofocus
              />
            </div>
          </div>
          <div class="p-formgrid grid">
            <div class="p-field col">
              <label for="marca">Marca</label>
              <InputText
                autocomplete="off"
                id="marca"
                v-model.trim="equipo.Marca"
                required="true"
                autofocus
                :class="{ 'p-invalid': submitted && !equipo.Marca }"
              />
              <small class="p-invalid" v-if="submitted && !equipo.Marca"
                >La marca es requerida.</small
              >
              <span
                v-if="equipo.DatosOCS && ( (equipo.DatosOCS.SMANUFACTURER && equipo.DatosOCS.SMANUFACTURER.toLowerCase() != equipo.Marca?.toLowerCase()))"
                class="pi pi-info-circle ml-1"
                style="font-size: 1.2rem; color: red"
                v-tooltip="'Valor según OCS:\n' + equipo.DatosOCS?.SMANUFACTURER + '\n\nClic para cambiar'"
                @click="equipo.Marca = equipo.DatosOCS?.SMANUFACTURER"
              ></span>
            </div>
            <div class="p-field col">
              <label for="modelo">Modelo</label>
              <InputText
                autocomplete="off"
                id="modelo"
                v-model.trim="equipo.Modelo"
                required="true"
                autofocus
                :class="{ 'p-invalid': submitted && !equipo.Modelo }"
              />
              <small class="p-invalid" v-if="submitted && !equipo.Modelo"
                >El modelo es requerido.</small
              >
              <span
                v-if="equipo.DatosOCS && ( (equipo.DatosOCS.SMODEL && equipo.DatosOCS.SMODEL.toLowerCase() != equipo.Modelo?.toLowerCase()))"
                class="pi pi-info-circle ml-1"
                style="font-size: 1.2rem; color: red"
                v-tooltip="'Valor según OCS:\n' + equipo.DatosOCS?.SMODEL + '\n\nClic para cambiar'"
                @click="equipo.Modelo = equipo.DatosOCS?.SMODEL"
              ></span>
            </div>
          </div>
    
          <div class="p-formgrid grid">
            <div class="p-field col">
              <label for="serie">No. serie</label>
              <InputText
                autocomplete="off"
                id="serie"
                v-model.trim="equipo.Serie"
                required="true"
                autofocus
              />
              <span
                v-if="equipo.DatosOCS && ( (equipo.DatosOCS.SSN && equipo.DatosOCS.SSN.toLowerCase() != equipo.Serie?.toLowerCase()))"
                class="pi pi-info-circle ml-1"
                style="font-size: 1.2rem; color: red"
                v-tooltip="'Valor según OCS:\n' + equipo.DatosOCS?.SSN + '\n\nClic para cambiar'"
                @click="equipo.Serie = equipo.DatosOCS?.SSN"
              ></span>
            </div>
            <div class="p-field col">
              <label for="so">Sistema Operativo</label>
              <InputText
                autocomplete="off"
                id="so"
                v-model.trim="equipo.SO"
                required="true"
                autofocus
              />
            </div>
          </div>
    
          <div class="p-formgrid grid">
            <div class="p-field col" v-show="!NoSegmentado">
              <label for="ip">IP</label>
              <InputText
                autocomplete="off"
                id="ip"
                v-model.trim="equipo.IP"
                required="true"
                autofocus
                :class="{ 'p-invalid': submitted && !equipo.IP }"
              />
              <small class="p-invalid" v-if="submitted && !equipo.IP"
                >La IP es requerida.</small
              >
            </div>
    
            <div class="p-field col">
              <label for="nni">NNI</label>
              <InputText
                autocomplete="off"
                id="ref"
                v-model.trim="equipo.NNI"
                autofocus
              />
            </div>
            <div class="p-field col-12">
              <label for="mac">MAC</label>
              <InputMask
                autocomplete="off"
                id="mac"
                v-model.trim="equipo.MAC"
                mask="**:**:**:**:**:**"
                autofocus
              />
              <span
                  v-if="equipo.DatosOCS && ( (equipo.DatosOCS.MAC && equipo.DatosOCS.MAC.toLowerCase() != equipo.MAC?.toLowerCase()))"
                  class="pi pi-info-circle ml-1"
                  style="font-size: 1.2rem; color: red"
                  v-tooltip="'Valor según OCS:\n' + equipo.DatosOCS?.MAC + '\n\nClic para cambiar'"
                  @click="equipo.MAC = equipo.DatosOCS?.MAC"
                ></span>
            </div>
            <div class="p-field col-12">
              <label for="Descripcion">Descripción</label>
              <Textarea
                autocomplete="off"
                id="ref"
                v-model.trim="equipo.Descripcion"
                autofocus
              />
            </div>
            <div class="p-field col-12">
              <label for="obs">Observaciones</label>
              <Textarea
                autocomplete="off"
                id="obs"
                v-model.trim="equipo.Observaciones"
                autofocus
              />
            </div>
          </div>
        </TabPanel>
        <TabPanel v-if="equipo?.Id_equipo_computo" header="Perifericos">
          <div class="grid">
            <div class="col-12 flex justify-content-end">
              <div>
                <Button
                    label="Nuevo periférico"
                    icon="pi pi-plus"
                    class="p-button-success mr-2 mb-2"
                    @click="agregarPeriferico()"
                />
              </div>
            </div>
            <div class="col-12">
              <DataTable
                :value="equipo.lstPerifericos"
                dataKey="Id_equipo_periferico"
                :globalFilterFields="[
                  'IP',
                  'Tipo',
                  'Marca',
                  'Modelo',
                  'Serie',
                  'NNI',
                  'MAC',
                  'Fecha_registro',
                  'Fecha_instalacion',
                  'Observaciones',
                ]"
                :loading="loadingPerifericos"
                scrollable
                responsiveLayout="scroll"
                scrollDirection="both"
                scrollHeight="300px"
              >
                <template #empty> No se encontraron registros. </template>
                <template #loadingPerifericos>
                  Cargando datos. Espere por favor.
                </template>
                <Column
                  field="BotonesPerifericos"
                  style="width: 10%"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                >
                  <template #body="slotProps">
                    <div class="flex align-item-center">
                      <Button
                        style="width: 30px; height: 30px; margin-right: 0px"
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-info"
                        @click="agregarPeriferico(slotProps.data)"
                      />
                      <Button
                        style="width: 30px; height: 30px; margin-right: 0px"
                        icon="pi pi-times"
                        class="p-button-rounded p-button-warning"
                        @click="eliminarPeriferico(slotProps.data)"
                      />
                    </div>
                  </template>
                </Column>
                <Column
                  field="IP"
                  style="width: 10rem"
                  header="IP"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                ></Column>
                <Column
                  field="Tipo"
                  style="width: 10rem"
                  header="TIPO"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                ></Column>
                <Column
                  field="Marca"
                  style="width: 12rem"
                  header="MARCA"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                ></Column>
                <Column
                  field="Modelo"
                  style="width: 10rem"
                  header="MODELO"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                ></Column>
                <Column
                  field="Serie"
                  style="width: 10rem"
                  header="SERIE"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                ></Column>
                <Column
                  field="MAC"
                  style="width: 10rem"
                  header="MAC"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                ></Column>
                <Column
                  field="NNI"
                  style="width: 10rem"
                  header="NNI"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                ></Column>
                <Column
                  field="Fecha_registro"
                  style="width: 15rem"
                  header="FECHA DE REGISTRO"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                  ><template #body="slotProps">
                    {{ getFechaWCF(slotProps.data.Fecha_registro, true) }}
                  </template>
                </Column>
                <Column
                  field="Fecha_mod"
                  style="width: 15rem"
                  header="FECHA DE MODIFICACIÓN"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                >
                  <template #body="slotProps">
                    {{ getFechaWCF(slotProps.data.Fecha_mod, true) }}
                  </template>
                </Column>
                <Column
                  field="Fecha_instalacion"
                  style="width: 15rem"
                  header="FECHA DE INSTALACIÓN"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                >
                  <template #body="slotProps">
                    {{ getFechaWCF(slotProps.data.Fecha_instalacion, true) }}
                  </template>
                </Column>
                <Column
                  field="Observaciones"
                  style="width: 15rem"
                  header="OBSERVACIONES"
                  :headerStyle="{
                    'background-color': '#6495ED',
                    color: '#fff',
                    'font-size': '9px',
                  }"
                  sortable
                ></Column>
              </DataTable>
            </div>
          </div>
        </TabPanel>

      </TabView>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarDialogo"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-text"
          @click="guardarEquipo"
        />
      </template>
    </Dialog>
    <ComponentFormPeriferico :perifericoFormulario="perifericoSeleccionado" :displayComponent="displayAgregarPeriferico" :unidadSeleccionada="equipo?.tUnidad?? null" @onClose="onCloseFormPeriferico" @onSave="onSaveFormPeriferico" @onDelete="onSaveFormPeriferico"></ComponentFormPeriferico>
</template>
<script>
import ServiceEquiposComputo from "../service/EquiposComputo";
import ServiceInventario from "../service/Inventario";
import { mapGetters } from "vuex";
import SrvrPerifericos from "../service/Perifericos";
import ComponentFormPeriferico from "./ComponentFormPeriferico.vue";
import Utilerias from "../utilidades/Utilerias";


    export default {
        props: {
            equipoFormulario : Object,
            displayComponent: Boolean
        },
        emits: ['onSave','onClose'],
        components:{
          ComponentFormPeriferico
        },
        data(){
            return {
                equipo : {},
                displayForm: false,
                submitted: false,
                lstUnidades: [],
                lstTipos: [
                  {
                    Tipo: "COMPUTADORA",
                  },
                  {
                    Tipo: "LAPTOP",
                  },
                  {
                    Tipo: "MULTIFUNCIONAL",
                  },
                  {
                    Tipo: "SERVIDOR",
                  },
                  {
                    Tipo: "PROVEEDOR",
                  },
                  {
                    Tipo: "IMPRESORA",
                  },
                  {
                    Tipo: "PANTALLA",
                  },
                  {
                    Tipo: "LECTOR DE BARRAS",
                  },
                  {
                    Tipo: "SCANNER",
                  },
                  {
                    Tipo: "DIADEMA",
                  },
                  {
                    Tipo: "CAMARA WEB",
                  },
                  {
                    Tipo: "UPS",
                  },
                ],
                modoEdicion : "",
                NoSegmentado: false,
                showAgregar: false,
                displayAgregarPeriferico: false,
                perifericoSeleccionado: null,
                loadingPerifericos: false,
                active: 0
            }
        },
        watch: {
          equipoFormulario(newValue){
            if(newValue){
              this.modoEdicion = "Editar";
              this.equipo = newValue;
              this.equipo.tUnidad = {};
              let unidad = {
                UNIDAD: this.equipo.Unidad,
                SUBRED: this.equipo.Subred,
                UNIDAD_SUBRED: this.equipo.Unidad + " (" + this.equipo.Subred + ")",
              };
              this.equipo.tUnidad = unidad;
              this.equipo.Id_usuario_mod = this.getUsuarioLogueado.Usuario.Id_usuario;
              this.equipo.tTipo = {};
              this.equipo.tTipo = { Tipo: this.equipo.Tipo };

            }else{
              this.modoEdicion = "Agregar";
              this.equipo = {};
            }
          },
          displayForm(newValue){
            this.displayForm = newValue;
          }
        },
        created(){
          this.getUnidades();
        },  
        methods:{
            escribeIP(obj) {
                return obj.IP;
            },
            guardarEquipo() {
                var t = this;
                this.submitted = true;

                if (this.NoSegmentado == false) {
                    if (
                    !t.equipo ||
                    !t.equipo.tUnidad ||
                    !t.equipo.tTipo ||
                    !t.equipo.Marca ||
                    !t.equipo.Modelo ||
                    !t.equipo.IP
                    ) {
                    return;
                    }

                    t.equipo.Unidad = t.equipo.tUnidad.UNIDAD;
                    t.equipo.Subred = t.equipo.tUnidad.SUBRED;

                    if (t.equipo.tTipo.Tipo) {
                    t.equipo.Tipo = t.equipo.tTipo.Tipo;
                    } else {
                    t.equipo.Tipo = t.equipo.tTipo;
                    }

                    if (!t.equipo.NNI) {
                    t.equipo.NNI = "";
                    }

                    if (!t.equipo.MAC) {
                    t.equipo.MAC = "";
                    }

                    if (!t.equipo.Usuario) {
                    t.equipo.Usuario = "";
                    }

                    if (!t.equipo.Nombre_equipo) {
                    t.equipo.Nombre_equipo = "";
                    }

                    if (!t.equipo.Serie) {
                    t.equipo.Serie = "";
                    }

                    if (!t.equipo.Ubicacion) {
                    t.equipo.Ubicacion = "";
                    }

                    if (!t.equipo.Area) {
                    t.equipo.Area = "";
                    }

                    if (!t.equipo.SO) {
                    t.equipo.SO = "";
                    }

                    if (!t.equipo.Descripcion) {
                    t.equipo.Descripcion = "";
                    }

                    if (!t.equipo.Observaciones) {
                    t.equipo.Observaciones = "";
                    }

                    t.equipo.Id_usuario_registro = t.getUsuarioLogueado.Usuario.Id_usuario;

                    if (!t.validarEstructuraIP(t.equipo.IP)) {
                    t.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "La IP ingresada no tiene una estructura válida.",
                        life: 5000,
                    });
                    return;
                    }
                    t.$confirm.require({
                            message: '¿Está seguro que desea guardar esta información?',
                            header: 'Confirmacion',
                            icon: 'pi pi-exclamation-triangle',
                            accept: () => {
                              var ctlSvr = new ServiceEquiposComputo();
                              if (t.modoEdicion == "Agregar") {
                              ctlSvr.addEquipoComputo(t, t.equipo).then(() => {
                                  t.$toast.add({
                                  severity: "success",
                                  summary: "AVISO",
                                  detail: "Equipo agregado correctamente",
                                  life: 3000,
                                  });
                                  t.cancelarDialogo();
                                  t.$emit('onSave');
                              });
                              } else {
                              ctlSvr.updateEquipoComputo(t, t.equipo).then(() => {
                                  t.$toast.add({
                                  severity: "success",
                                  summary: "AVISO",
                                  detail: "Equipo editado correctamente",
                                  life: 3000,
                                  });
                                  t.cancelarDialogo();
                                  t.$emit('onSave');
                              });
                              }
                            },
                            reject: () => {
                            }
                    });
                } else {
                    if (
                    !t.equipo ||
                    !t.equipo.tUnidad ||
                    !t.equipo.tTipo ||
                    !t.equipo.Ubicacion ||
                    !t.equipo.Marca ||
                    !t.equipo.Modelo
                    ) {
                    return;
                    }
                    t.equipo.Unidad = t.equipo.tUnidad.UNIDAD;
                    t.equipo.Subred = null;
                    t.equipo.IP = null;

                    if (t.equipo.tTipo.Tipo) {
                    t.equipo.Tipo = t.equipo.tTipo.Tipo;
                    } else {
                    t.equipo.Tipo = t.equipo.tTipo;
                    }

                    if (!t.equipo.NNI) {
                    t.equipo.NNI = "";
                    }

                    if (!t.equipo.MAC) {
                    t.equipo.MAC = "";
                    }

                    if (!t.equipo.Observaciones) {
                    t.equipo.Observaciones = "";
                    }

                    if (!t.equipo.Usuario) {
                    t.equipo.Usuario = "";
                    }

                    if (!t.equipo.Nombre_equipo) {
                    t.equipo.Nombre_equipo = "";
                    }

                    if (!t.equipo.Serie) {
                    t.equipo.Serie = "";
                    }

                    if (!t.equipo.Ubicacion) {
                    t.equipo.Ubicacion = "";
                    }

                    if (!t.equipo.Area) {
                    t.equipo.Area = "";
                    }

                    if (!t.equipo.SO) {
                    t.equipo.SO = "";
                    }

                    if (!t.equipo.Descripcion) {
                    t.equipo.Descripcion = "";
                    }

                    if (!t.equipo.Observaciones) {
                    t.equipo.Observaciones = "";
                    }

                    t.equipo.Id_usuario_registro = t.getUsuarioLogueado.Usuario.Id_usuario;

                    t.$confirm.require({
                      message: '¿Está seguro que desea guardar esta información?',
                      header: 'Confirmacion',
                      icon: 'pi pi-exclamation-triangle',
                      accept: () => {
                        var ctlSvr2 = new ServiceEquiposComputo();
                        if (t.modoEdicion == "Agregar") {
                        ctlSvr2.addEquipoComputo(t, t.equipo).then(() => {
                            t.$toast.add({
                            severity: "success",
                            summary: "AVISO",
                            detail: "Equipo agregado correctamente",
                            life: 3000,
                            });
                            t.cancelarDialogo();
                            t.cargaEquiposNoSegmentados();
                        });
                        } else {
                        ctlSvr2.updateEquipoComputo(t, t.equipo).then(() => {
                            t.$toast.add({
                            severity: "success",
                            summary: "AVISO",
                            detail: "Equipo editado correctamente",
                            life: 3000,
                            });
                            t.cancelarDialogo();
                            t.cargaEquiposNoSegmentados();
                        });
                        }
                      },
                      reject: () => {
                      }
                    });
                }
            },
            cancelarDialogo() {
                this.submitted = false;
                this.showAgregar = false;
                this.displayAgregarPeriferico = false;
                this.modoEdicion = "";
                this.equipo = {};
                this.perifericoSeleccionado = null;
                this.NoSegmentado = false;
                this.active = 0;
                this.$emit('onClose');
                //this.reiniciaEquipo();
            },
            validarEstructuraIP(ip) {
                const ipRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
                return ipRegex.test(ip);
            },
            getUnidades(){
              var t = this;
              var serviceInventario = new ServiceInventario();
              serviceInventario.getUnidades(t).then((res) => {
                t.lstUnidades = res;
              });
            },
            cargaPerifericos() {
                var t = this;
                var ctlSvr = new SrvrPerifericos();
                t.loadingPerifericos = true;
                if (!(t.equipo?.Id_equipo_computo)) {
                    t.equipo.lstPerifericos = [];
                    t.loadingPerifericos = false;
                } else {
                    ctlSvr.getPerifericosPorEquipo(t, t.equipo.Id_equipo_computo).then((res) => {
                      t.loadingPerifericos = false;
                      t.equipo.lstPerifericos = res;
                    });
                }
            },
            tabChange(index){
              if(index == 1 && this.equipo){
                this.cargaPerifericos();
              }
            },
            agregarPeriferico(periferico = null){
              if(this.equipo?.Id_equipo_computo){
                this.perifericoSeleccionado = {...periferico, Id_equipo_computo : this.equipo.Id_equipo_computo};
                this.displayAgregarPeriferico = true;
              }else{
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "No se a seleccionado un equipo de computo asociado.",
                    life: 5000,
                });
              }
            },
            onCloseFormPeriferico(){
              this.displayAgregarPeriferico = false;
            },
            onSaveFormPeriferico(){
              this.displayAgregarPeriferico = false;
              this.cargaPerifericos();
            },
            getFechaWCF(fecha, hora) {
              var utils = new Utilerias();
              return utils.getFechaWCF(fecha, hora);
            },
            eliminarPeriferico(obj) {
                var t = this;
                t.$confirm.require({
                        message: '¿Está seguro de eliminar este periferico?',
                        header: 'Confirmacion',
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            let id_usuario = t.getUsuarioLogueado.Usuario.Id_usuario;
                            var val = obj.Id_equipo_periferico;
                            //this.periferico.Id_equipo_computo = this.idEquiposAbiertos.Id_equipo_computo;
                            var ctlSvr = new SrvrPerifericos();
                            ctlSvr.deletePeriferico(t, val, id_usuario).then(() => {
                            t.$toast.add({
                                severity: "success",
                                summary: "AVISO",
                                detail: "Dispositivo eliminado correctamente",
                                life: 3000,
                            });
                            t.cargaPerifericos();
                            // let equipo = t.lstEquipos.find(
                            //     (e) => e.Id_equipo_computo == obj.Id_equipo_computo
                            // );
                            // t.cargaPerifericos(equipo);
                            // if (equipo) {
                            //     equipo.num_perifericos--;
                            // }
                            });
                        },
                        reject: () => {
                        }
                });
            },
        },
        computed: {
          ...mapGetters(["getUrlServicios", "getUsuarioLogueado"]),
        },
    }
</script>